import Yup from 'yup';

export const generateValidationSchema = jobPost => {
  return Yup.object().shape({
    email: Yup.string().required('This field is required'),
    phone: Yup.string().required('This field is required'),
    coverLetter:
      jobPost.coverLetter === 'required'
        ? Yup.string().required('This field is required')
        : Yup.string()
  });
};

export const getInitialFormValues = currentUser => {
  const { email, profile } = currentUser;
  const { mobilePhone, workPhone } = profile;

  return {
    email,
    phone: mobilePhone || workPhone,
    coverLetter: ''
  };
};
